<template>
  <div class="aside-box" :style="asidePopupStyle">
    <slot></slot>
  </div>
</template>

<script type="text/javascript">
import globalConfig from '../../utiles/globalConfig'
export default {
  data() {
    return {
      menuBottom: Math.ceil(
        Number(globalConfig.getHrefParam('menuBottom') || 0) /
          (window.devicePixelRatio || 1)
      )
    }
  },
  computed: {
    asidePopupStyle() {
      const safeDistance = 30
      return `top: unset; bottom: 0; height: ${
        window.innerHeight - this.menuBottom - safeDistance
      }px`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_dimen';
@import '../../assets/scss/_mixins';
$img: '../../assets/image/';
.aside-box {
  overflow: hidden;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: white;
  z-index: 1002;
  border-radius: 24px 24px 0 0;

  .close {
    position: absolute;
    width: 59vh;
    height: 258vh;
    top: 50%;
    left: -59vh;
    margin-top: -129vh;
    z-index: -1;
    background: url($img + 'close-btn.png') no-repeat center center;
    background-size: contain;
    @extend %hover;
  }
}
</style>
